import React, { Component } from "react";
import axios from "axios";
import { Form, Formik } from "formik";
import PropTypes from "prop-types";
import {
  StyledMembersWrapper,
  StyledShareWeb,
  StyledWorkspaceName,
} from "../styled/styles";
import Format from "string-format";
import {
  ADD_NEW_TEAM_MEMBER,
  DELETE_MEMBER,
  ROLES_ENDPOINT,
  SHARED_ITEMS_ENDPOINT,
} from "../../_actions/endpoints";
import { PREVIEW, USER_HOME } from "../../_utils/routes";
import { connect } from "react-redux";
import { updateStory } from "../../_actions/storiesActions";
import {
  analyticsTrackEvent,
  getAuthToken,
  isAuthorizeToChangeWorkspaceUserRole,
} from "../../_utils/common";
import { INVITE_USER_TO_CONTENT_VALIDATION_SCHEMA } from "../../_validation/inviteUserToContent";
import { findIndex, isEqual } from "lodash";
import OrgMembers from "../settings/OrgMembers";
import UserInviteForm from "../settings/UserInviteForm";
import { ShowCenterSpinner } from "./statelessView";
import {
  Box,
  Divider,
  Flex,
  HStack,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  Text,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { showToast } from "../../_utils/showToast";
import { t } from "i18next";
import { Clipboard } from "../../_utils/copyToClipboard";
import { handleHTTPError } from "../../_actions/errorHandlerActions";
import { switchWorkspace, syncWorkspaces } from "../../_actions/authActions";
import { withRouter } from "react-router-dom";

const format = require("string-format");

const ShareLink = ({
  shareLink,
  onSetCopy,
  isCopied,
  isSharingEnabled,
  onHandleSwitch,
}) => (
  <Formik enableReinitialize initialValues={{ link: shareLink }}>
    {({ values, handleChange, handleBlur }) => (
      <StyledShareWeb>
        <div className="control">
          <div className="info">
            <div className="title">
              {t("share.share_preview", { ns: "studio" })}
            </div>
            <div className="subtitle">
              {t("share.anyone", { ns: "studio" })}
            </div>
          </div>
          <div className="toggle">
            <Switch
              onChange={() => onHandleSwitch(isSharingEnabled)}
              isChecked={isSharingEnabled}
              textAlign={"right"}
              pt={"12px"}
            />
          </div>
        </div>
        {isSharingEnabled && (
          <Form style={{ marginTop: "0.5rem" }}>
            <Flex direction="row">
              <InputGroup>
                <Input
                  readOnly={true}
                  type="text"
                  name="link"
                  defaultValue={shareLink}
                  placeholder={t("share.copy_link", { ns: "studio" })}
                  value={values.link}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </InputGroup>
              <Box ml={2}>
                <Clipboard
                  value={shareLink}
                  withText={true}
                  variant="secondary"
                  fullwidth={false}
                />
              </Box>
            </Flex>
          </Form>
        )}
      </StyledShareWeb>
    )}
  </Formik>
);

export class TldrShare extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      members: [],
      roles: [],
      sharedUsers: [],
      shareLink: this.getSharelink(),
      isCopied: false,
      isSharingEnabled: props?.story?.payload?.access === 2,
    };
  }

  onHandleSwitch = (isEnabled) => {
    this.setState({
      isSharingEnabled: !this.state.isSharingEnabled,
    });

    const storyId = this.props.story.payload.id;

    this.props.updateStory(
      storyId,
      {
        access: isEnabled ? 1 : 2,
        share: 1,
      },
      this.signal,
      { ...this.props }
    );
    if (isEnabled) {
      this.setState({
        shareLink: this.getSharelink(),
      });
    }
  };

  onSetCopy = () => {
    this.setState(
      {
        isCopied: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            isCopied: false,
          });
        }, 3000);
      }
    );
    analyticsTrackEvent("copiedSharedLink");
  };

  onAddUser = (newUser) => {
    this.setState({
      members: this.state.members.concat(newUser),
      loaded: true,
    });
  };

  onAction = (action, member) => {
    if (action === "remove") {
      axios
        .delete(Format(DELETE_MEMBER, this.props.org.id, member.id))
        .then((res) => {
          this.setState({
            members: this.state.members.filter(function (_member) {
              return _member.id !== member.id;
            }),
          });
        })
        .catch((error) => {});
    }
    if (action === "remind") {
      const userData = {
        email: member.email,
        is_admin: member.is_admin,
      };
      axios
        .post(
          ADD_NEW_TEAM_MEMBER +
            this.props.auth.payload.selectedOrg +
            "/members",
          userData,
          { params: { remind_me: true } }
        )
        .then((res) => {
          showToast({
            description: t("reminder_Sent", { ns: "common" }),
            title: t("success", { ns: "common" }),
            status: "success",
          });
        })
        .catch((error) => {
          showToast({
            description: t("errors.failed_to_send", { ns: "common" }),
            title: t("oops", { ns: "common" }),
            status: "error",
          });
        });
    }
  };

  onEmailChange = (e) => {
    this.validateField(e.target.name, e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  };

  getPreviewUrl = () => {
    return format(
      PREVIEW,
      this.props.auth.payload.selectedOrg,
      this.props?.story?.payload?.id,
      encodeURIComponent(this.props?.story?.payload?.title)
    );
  };

  componentDidMount() {
    this.fetchUserRoles();
    const { contentId } = this.props;
    this.fetchItemUserList(contentId);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!isEqual(prevProps?.story?.payload, this.props?.story?.payload)) {
      this.setState({
        shareLink: this.getSharelink(),
      });
    }
  }

  getSharelink = () => {
    return window.location.origin + encodeURI(this.getPreviewUrl());
  };

  render() {
    const { loaded, members, roles, sharedUsers } = this.state;
    const { onHide, auth, org, contentType, contentId, t } = this.props;
    const storyId = this.props.story?.payload?.id;
    const authenticatedUserId = auth?.payload?.user.pk;
    return (
      <div>
        <Modal isOpen={true} onClose={onHide} isCentered size="lg">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader p="4">
              <HStack alignItems="center" justify="space-between">
                <Text>
                  {storyId
                    ? t("share_modal.modal_title")
                    : t("share_modal.modal_title_invite")}
                </Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton />
            <Divider my="0" />

            <ModalBody p="4">
              {loaded ? (
                <Box>
                  {storyId && (
                    <>
                      <ShareLink
                        shareLink={this.state.shareLink}
                        isCopied={this.state.isCopied}
                        onSetCopy={this.onSetCopy}
                        isSharingEnabled={this.state.isSharingEnabled}
                        onHandleSwitch={this.onHandleSwitch}
                      />
                      <Divider my="0" style={{ borderTopWidth: "2px" }} />
                    </>
                  )}
                  {
                    <UserInviteForm
                      roles={roles}
                      onInvite={this.sendInvite}
                      validationSchema={
                        INVITE_USER_TO_CONTENT_VALIDATION_SCHEMA
                      }
                      initialValues={{
                        email: "",
                        role: roles?.length > 0 && roles[0].id,
                        content_id: contentId,
                        content_type: contentType,
                      }}
                    />
                  }
                  <StyledMembersWrapper>
                    <OrgMembers
                      members={members}
                      roles={roles}
                      isWorkspaceSettings={false}
                      isAuthorizeToChangeRole={isAuthorizeToChangeWorkspaceUserRole(
                        authenticatedUserId,
                        members
                      )}
                      onAction={this.onSharedContentMemberAction}
                    />
                  </StyledMembersWrapper>
                </Box>
              ) : (
                <Box style={{ width: "100%", minHeight: "300px" }}>
                  <ShowCenterSpinner loaded={false} />
                </Box>
              )}
            </ModalBody>
            <Divider my="0" />

            <ModalFooter style={{ justifyContent: "flex-start" }} p="4">
              <Box>
                {t("share_modal.modal_footer_first_txt")}{" "}
                <StyledWorkspaceName>{org?.name}</StyledWorkspaceName>{" "}
                {t("share_modal.modal_footer_second_txt")}
              </Box>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    );
  }

  sendInvite = (formValues, { setSubmitting, resetForm, setErrors }) => {
    formValues["content_role"] = formValues.role;
    // convert email address into lowercase
    if (formValues?.email) {
      formValues.email = formValues.email.toLowerCase();
    }
    return axios
      .post(`${SHARED_ITEMS_ENDPOINT}`, formValues)
      .then((response) => {
        setSubmitting(false);
        this.setState({
          ...this.state,
          members: this.state.members.concat({
            ...response.data.user,
            content_id: response.data.content_id,
            content_role: response.data.content_role,
            share_content_id: response.data.id,
          }),
        });
        analyticsTrackEvent("inviteMembers", {
          location: "sharingModal",
        });
        showToast({
          description: t("shared_successfully", { ns: "common" }),
          title: t("success", { ns: "common" }),
          status: "success",
        });
        resetForm();
      })
      .catch((error) => {
        setSubmitting(false);
        console.error(error.response.data);
        if (error.response.data?.length > 0) {
          setErrors({ email: error.response.data[0] });
          showToast({
            description:
              error.response.data[0] ||
              t("errors.failed_to_share", { ns: "common" }),
            title: t("error", { ns: "common" }),
            status: "error",
          });
        }
      });
  };

  fetchUserRoles = () => {
    const categoryName = this.props.contentType;
    axios
      .get(`${ROLES_ENDPOINT}?category__name=${categoryName}`)
      .then((response) => {
        const roles = response.data.results;
        let userRoles = roles.map((role) => ({
          ...role,
          value: role.name,
          label: role.display_name, // TODO: role.displayName
        }));
        this.setState({
          ...this.state,
          roles: userRoles,
        });
      });
  };

  fetchItemUserList = (objectId) => {
    axios
      .get(`${SHARED_ITEMS_ENDPOINT}?content_id=${objectId}`)
      .then((response) => {
        const sharedUsers = response.data.results;
        this.setState({
          ...this.state,
          members: sharedUsers.map((shareUser) => {
            return {
              ...shareUser.user,
              content_id: shareUser.content_id,
              content_role: shareUser.content_role,
              share_content_id: shareUser.id,
            };
          }),
          loaded: true,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  onChangeMemberRole = (member, role) => {
    const { contentType, contentId } = this.props;
    axios
      .put(`${SHARED_ITEMS_ENDPOINT}/${member.share_content_id}`, {
        content_type: contentType,
        content_id: contentId,
        content_role: role.id,
      })
      .then((response) => {
        const updatedInfo = response.data;

        const existingMembers = this.state.members;
        const index = findIndex(
          existingMembers,
          (member) => member.share_content_id === updatedInfo.id
        );
        if (index > -1) {
          existingMembers[index] = {
            ...updatedInfo.user,
            content_id: updatedInfo.content_id,
            content_role: updatedInfo.content_role,
            share_content_id: updatedInfo.id,
          };

          this.setState({
            ...this.state,
            members: [...existingMembers],
          });
        }
        showToast({
          description: t("role_updated", { ns: "common" }),
          title: t("success", { ns: "common" }),
          status: "success",
        });
      })
      .catch((error) => console.error(error));
  };

  onRemind = (member, role) => {
    const { contentType, contentId } = this.props;
    axios
      .post(`${SHARED_ITEMS_ENDPOINT}`, {
        remind_me: true,
        content_type: contentType,
        content_id: contentId,
        email: member.email,
        content_role: member.content_role.id,
      })
      .then((response) => {
        showToast({
          description: t("reminded_user", { ns: "common" }),
          title: t("success", { ns: "common" }),
          status: "success",
        });
      })
      .catch((error) => {});
  };

  onRemoveMember = (member, role) => {
    axios
      .delete(`${SHARED_ITEMS_ENDPOINT}/${member.share_content_id}`)
      .then((response) => {
        this.setState({
          ...this.state,
          members: this.state.members.filter(
            (_member) => _member.share_content_id !== member.share_content_id
          ),
        });
        showToast({
          description: t("removed_user", { ns: "common" }),
          title: t("success", { ns: "common" }),
          status: "success",
        });
      })
      .catch((error) => console.error(error));
  };
  onLeaveWorkspace = (member, role) => {
    axios
      .delete(`${SHARED_ITEMS_ENDPOINT}/${member.share_content_id}`)
      .then((res) => {
        showToast({
          description: t("success.leave_workspace.message", {
            ns: "workspace",
          }),
          title: t("success.leave_workspace.heading", { ns: "workspace" }),
          status: "success",
        });
        const foundOrgId = this.props.auth.payload?.orgs.find(
          (org) => org.id !== this.props.auth.payload?.selectedOrg
        )?.id;

        this.props.switchWorkspace(foundOrgId, getAuthToken());
        this.props.syncWorkspaces();
      })
      .catch((error) => {
        showToast({
          description: t("failure.remove.message", { ns: "workspace" }),
          title: t("failure.remove.heading", { ns: "workspace" }),
          status: "error",
        });
        handleHTTPError(error);
      })
      .finally(() => {
        this.props.history.push(USER_HOME);
      });
  };

  onSharedContentMemberAction = (action, actionData) => {
    const { role, member } = actionData;
    switch (action) {
      case "changeRole":
        this.onChangeMemberRole(member, role);
        break;
      case "remind":
        this.onRemind(member, role);
        break;
      case "remove":
        this.onRemoveMember(member, role);
        break;
      case "leave":
        this.onLeaveWorkspace(member, role);
        break;
      default:
        return;
    }
  };
}

TldrShare.propTypes = {
  auth: PropTypes.object.isRequired,
  org: PropTypes.object.isRequired,
  contentType: PropTypes.string.isRequired,
  contentId: PropTypes.string.isRequired,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  story: state.story,
});

const mapDispatchToProps = (dispatch) => ({
  updateStory: (storyId, data, signal, props) =>
    dispatch(updateStory(storyId, data, signal, props)),
  syncWorkspaces: () => dispatch(syncWorkspaces()),
  switchWorkspace: (workspaceId, token) =>
    dispatch(switchWorkspace(workspaceId, token)),
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TldrShare))
);
